module.exports = __webpack_public_path__ + "static/media/undraw_editable_re_4l94.e1fd3e24.svg";